import {
    CLEAR,
    LOGIN_REQUEST,
    LOGIN_SUCCESSFUL,
    LOGIN_FAILED,
    LOGIN_SET_AUTHENTICATE,
    LOGOUT_REQUEST,
    TWO_FA_LOGIN_REQUEST,
    LOGIN_OPEN_PINCODE_MODAL,
    LOGIN_SAVE_2FA_AUTH_INFO,
    PASSWORD_TOO_WEAK,
    LOGIN_SET_AUTH_METHODS,
    INIT_AZURE_AUTH,
    LOGIN_VIA_AZURE,
    HANDLE_AZURE_REDIRECT,
    BRIDGE_SSO_SETTLED,
} from './types';

export const clear = () => ({ type: CLEAR });
export const loginRequest = (login, password, reCAPTCHAsiteKey, history) => ({
    type: LOGIN_REQUEST,
    payload: {
        login,
        password,
        reCAPTCHAsiteKey,
        history,
    },
});
export const loginSuccessful = () => ({ type: LOGIN_SUCCESSFUL });
export const loginFailed = () => ({ type: LOGIN_FAILED });
export const loginSetAuthenticate = isAuthenticate => ({ type: LOGIN_SET_AUTHENTICATE, payload: isAuthenticate });
export const logoutRequest = () => ({ type: LOGOUT_REQUEST });
export const twoFAloginRequest = payload => ({ type: TWO_FA_LOGIN_REQUEST, payload });
export const loginOpenPinCodeModal = payload => ({ type: LOGIN_OPEN_PINCODE_MODAL, payload });
export const save2FAuthInfo = payload => ({ type: LOGIN_SAVE_2FA_AUTH_INFO, payload });
export const passwordTooWeak = payload => ({ type: PASSWORD_TOO_WEAK, payload });
/**
 * Action to set authentication methods.
 * @param {Object} authMethods
 * @returns {Object} Action object with type and payload.
 */
export const setAuthMethods = authMethods => ({
    type: LOGIN_SET_AUTH_METHODS,
    payload: authMethods,
});
/**
 * Action to initialize Azure authentication.
 * @returns {Object} Action object with type INIT_AZURE_AUTH.
 */
export const initAzureAuth = () => ({ type: INIT_AZURE_AUTH });
/**
 * Action to trigger login via Microsoft Azure.
 * @returns {Object} Action object with type LOGIN_VIA_AZURE.
 */
export const loginViaAzure = () => ({ type: LOGIN_VIA_AZURE });
export const handleAzureRedirect = () => ({ type: HANDLE_AZURE_REDIRECT });
/**
 * Action reporting that the SSO bridge has stopped trying, one way or another.
 *
 * Until it fires, the app holds its render: an anonymous bridged arrival would
 * otherwise fall through to the login screen for the length of the silent
 * login, and flash a screen the user is about to be taken off.
 *
 * @returns {Object} Action object with type BRIDGE_SSO_SETTLED.
 */
export const bridgeSsoSettled = () => ({ type: BRIDGE_SSO_SETTLED });
